module.exports = __webpack_public_path__ + "img/home-bg-bm.8c621427.png";